import React from 'react';
import { v4 as uuid } from 'uuid';
import ChannelSelectorOption from '../ChannelSelectorOption';

const ChannelSelectOptionGroup = (props) => {
  const { groupName, channels, onSelect } = props;

  const channelToOption = (channel) => {
    const key = `send_via_${channel.id}`;
    return (
      <ChannelSelectorOption key={key} channel={channel} onSelect={onSelect} />
    );
  };

  const options = channels.map(channelToOption);

  const spanId = `ChannelSelectOptionGroup-${uuid()}`;

  return (
    <div
      className="ChannelSelector__optionGroup"
      hidden={channels.length === 0}
    >
      <span id={spanId} className="ChannelSelector__optionGroup__header">
        {groupName}
      </span>
      <div role="region" aria-labelledby={spanId}>
        {options}
      </div>
    </div>
  );
};

export default ChannelSelectOptionGroup;
